const NotFoundPage = () => {
  return <div style={{ color: 'white' }}>Not Found Page</div>
}

export default NotFoundPage
